import { colors } from '@components/theme/styles/index';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { styled } from '@mui/system';
import { rem } from 'polished';

export const TemplatesModal = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '100%',
    maxWidth: rem(1000),

    [theme.breakpoints.up('lg')]: {
      maxWidth: rem(1210),
    },
  },
}));

export const TemplatesHeader = styled('div')(
  ({ theme }) =>
    ({
      display: 'flex',
      flexDirection: 'column',
      gap: rem(20),
      padding: `${rem(18)} ${rem(30)}`,

      [theme.breakpoints.up('md')]: {
        padding: `${rem(22)} ${rem(30)} ${rem(22)} ${rem(30)}`,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 0,
      },
    }) as any,
);

export const SearchContainer = styled(Box)(({ theme }) => ({
  flexGrow: 0,
  width: rem(360),

  '& > div': {
    height: rem(40),
  },

  [theme.breakpoints.up('lg')]: {
    minWidth: rem(330),
  },

  [theme.breakpoints.up('xl')]: {
    minWidth: rem(511),
  },
}));

export const SearchAndActionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',

  [theme.breakpoints.up('md')]: {
    padding: `${rem(10)} 0`,
  },

  [theme.breakpoints.up('lg')]: {
    flexDirection: 'column',
    padding: 0,
  },
}));

export const HeaderTitle = styled(DialogTitle)(({ theme }) => ({
  // padding: `${rem(30)} ${rem(0)}`,
  padding: 0,
}));

export const TemplatesHeaderTop = styled('div')(
  ({ theme }) =>
    ({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',

      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
      },

      '.MuiDialogTitle-root': {},
    }) as any,
);

export const TemplatesHeaderActions = styled('div')(
  ({ theme }) =>
    ({
      gap: rem(10),
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',

      [theme.breakpoints.down('md')]: {
        '& > button': {
          minHeight: rem(20),
          padding: `${rem(4)} ${rem(8)}`,
        },
      },

      [theme.breakpoints.up('md')]: {
        gap: rem(12),
        paddingRight: 0,
        paddingBottom: 0,
      },

      button: {
        flexShrink: 0,
      },
    }) as any,
);

export const TemplateCards = styled('div')(
  ({ theme }) =>
    ({
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
      gap: rem(10),

      [theme.breakpoints.up('md')]: {
        gap: rem(20),
      },
    }) as any,
);

export const TemplateCard = styled('div')<{ $active: boolean }>(
  ({ $active, theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
    aspectRatio: '1 / 1',
    backgroundColor: colors.grayLight2,
    borderRadius: rem(10),
    overflow: 'hidden',
    border: `${rem(2)} solid ${colors.grayLight2}`,
    cursor: 'pointer',

    ...($active && {
      border: `${rem(2)} solid ${colors.primary}`,
    }),

    [theme.breakpoints.up('md')]: {
      '&:hover': {
        border: `${rem(2)} solid ${colors.secondary}`,
      },
    },
  }),
);

export const TemplatesMobileClose = styled(IconButton)({
  width: rem(30),
  height: rem(30),
  fontSize: rem(12),
  border: `1px solid ${colors.gray}`,
});

export const TemplateContent = styled(DialogContent)<{ $loading?: boolean }>(
  ({ $loading }) => ({
    minHeight: rem(500),

    ...($loading && {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
    }),
  }),
);

export const TemplatePaginationArrows = styled(IconButton)<{
  $right?: boolean;
}>(({ $right }) => ({
  top: '50%',
  left: rem(10),
  width: rem(40),
  height: rem(40),
  position: 'absolute',
  border: `${rem(1)} solid ${colors.gray}`,
  fontSize: rem(16),
  transform: 'translateY(-50%)',
  zIndex: 5,
  backgroundColor: colors.white,

  ...($right && {
    left: 'auto',
    right: rem(10),
  }),

  '&:hover': {
    backgroundColor: colors.grayLight2,
  },
}));
